import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useCertificationBundleQuery } from '@/generated/graphql';
import { BackendSourceOptions, BrowseEventTrackingProvider } from '@udemy-v2/react-browse-event-tracking';
import { FrequentlyBoughtTogether } from '@udemy-v2/react-bundle-unit';
import { AddToCartButton } from '@udemy-v2/react-shopping-buttons';
import { generateTrackingId } from '@udemy-v2/event-tracking';
import { useI18n } from '@udemy-v2/i18n';
import type { Course } from '@udemy-v2/browse-course';
interface CertificationBundleProps {
  bundleCourseIds: string[];
}
export const CertificationBundle = t0 => {
  const $ = _c(23);
  const {
    bundleCourseIds
  } = t0;
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] !== bundleCourseIds) {
    t1 = {
      ids: bundleCourseIds
    };
    $[0] = bundleCourseIds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data,
    isLoading
  } = useCertificationBundleQuery(t1);
  data?.courses;
  let t2;
  if ($[2] !== data?.courses) {
    const filteredCourses = data?.courses?.filter(_temp) ?? [];
    t2 = filteredCourses.map(_temp2);
    $[2] = data?.courses;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const courses = t2;
  if (isLoading || courses.length === 0) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      backendSource: BackendSourceOptions.DISCOVERY
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== gettext) {
    t4 = gettext("Prepare for your certification exam with confidence");
    $[5] = gettext;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== gettext) {
    t5 = gettext("Get this top-rated course, plus a collection of practice tests, to prepare for your exam in one convenient bundle!");
    $[7] = gettext;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = courses as Course[];
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      openInNewTab: true,
      hideDescription: true
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== courses) {
    t8 = courses.map(_temp3);
    $[10] = courses;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== gettext) {
    t9 = gettext("Add all to cart");
    $[12] = gettext;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      size: "large"
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t8 || $[16] !== t9) {
    t11 = <AddToCartButton buyables={t8} addToCartButtonText={t9} forceRedirectToCart={true} buttonStyleProps={t10} />;
    $[15] = t8;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t12 = <BrowseEventTrackingProvider browseEventTrackingContext={t3}><FrequentlyBoughtTogether title={t4} description={t5} courses={t6} options={t7} addToCartButton={t11} /></BrowseEventTrackingProvider>;
    $[18] = t11;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
function _temp(course) {
  return course !== null;
}
function _temp2(course_0) {
  return {
    ...(course_0 as Course),
    frontendTrackingId: generateTrackingId()
  };
}
function _temp3(course_1) {
  return {
    id: Number(course_1.id),
    buyableObjectType: "course",
    frontendTrackingId: course_1.frontendTrackingId
  };
}